import request from '@/utils/request'

// 获取全部字典列表
export function fetchDictAll(query) {
  return request({
    url: '/common/modeldict/all',
    method: 'get',
    params: query
  })
}

// 新增字典数据
export function createDict(data) {
  return request({
    url: '/common/modeldict/create',
    method: 'post',
    data
  })
}
